var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import * as React from 'react';
import { createRoot } from 'react-dom/client';
import { findOrCreateElementAndInject } from '../../utils';
import { useApplePay } from '../../hooks/useApplePay';
import './ApplePayButton.css';
import { getDefaultValues } from '../../utils/defaultValues';
import { ButtonStyle, Edges, ThemeMode } from '../../constants';
import { GetEvents, useGetEvents } from '../../hooks/useGetEvents';
var ApplePay = React.memo(function (props) {
    var mappedProps = getDefaultValues(props);
    var _a = useApplePay(mappedProps), loading = _a.loading, onApplePayButtonClicked = _a.onApplePayButtonClicked, disabled = _a.disabled, abortApplePaySession = _a.abortApplePaySession;
    var onEventReceieved = React.useCallback(function (event) {
        if (event === GetEvents.ABORT) {
            abortApplePaySession();
        }
    }, [abortApplePaySession]);
    useGetEvents(onEventReceieved);
    React.useEffect(function () {
        if (props.debug) {
            console.log('ApplePayButtonProps', props);
        }
    }, []);
    return (_jsx("button", { className: 'button-applepay-tap', style: {
            ApplePayButtonType: mappedProps.interface.type,
            ApplePayButtonStyle: mappedProps.interface.theme === ThemeMode.DARK ? ButtonStyle.Black : ButtonStyle.White,
            borderRadius: mappedProps.interface.edges === Edges.STRAIGHT ? '0' : '10px'
        }, onClick: function (e) {
            var _a;
            e.preventDefault();
            onApplePayButtonClicked();
            (_a = props.onClick) === null || _a === void 0 ? void 0 : _a.call(props);
        }, lang: mappedProps.interface.locale, disabled: loading || disabled }));
});
export function ApplePayButton(props) {
    return _jsx(ApplePay, __assign({}, props));
}
export function abortApplePaySession() {
    window.postMessage({ event: GetEvents.ABORT }, '*');
}
var tapConnectInstance = null;
export var render = function (props, elementId) {
    if (tapConnectInstance) {
        return tapConnectInstance;
    }
    var el = findOrCreateElementAndInject(elementId);
    var root = createRoot(el);
    root.render(_jsx(ApplePayButton, __assign({}, props)));
    var unmount = function () {
        root.unmount();
        tapConnectInstance = null;
    };
    tapConnectInstance = { unmount: unmount };
    return tapConnectInstance;
};
